import {
  TrackRound,
  getDriverTimesWithLastPos,
} from "model/Match/Track/TrackRound";
import {
  statRoundsFirstRate,
  statRoundsAfPercentile,
  statRoundsLastRate,
} from "stats/RoundStats";
import {
  statTimesBest,
  statTimesDnfRate,
  statTimesMedian,
} from "stats/TimeStats";

export type DriverTrackStats = {
  orgId: string | undefined;
  orgName: string | undefined;
  driverName: string;
  driverRating: number | undefined;
  bestTime: number | undefined;
  medianTime: number | undefined;
  averageFinishPercentile: number | undefined;
  // Split rate/breakdown for shallowEqual in selectors
  firstRate: number | undefined;
  firstBreakdown: string;
  lastRate: number | undefined;
  lastBreakdown: string;
  // mistakeRate: number | undefined;
  // mistakeBreakdown: string;
  // crashRate: number | undefined;
  // crashBreakdown: string;
  dnfRate: number | undefined;
  dnfBreakdown: string;
};

export const getDriverTrackStats = (
  driverId: string,
  orgId: string | undefined,
  orgName: string | undefined,
  driverName: string,
  driverRating: number | undefined,
  rounds: TrackRound[]
): DriverTrackStats => {
  const roundTimesWithLastPos = getDriverTimesWithLastPos(rounds, driverId);
  const roundTimes = roundTimesWithLastPos.map((r) => r.time);
  const bestTime = statTimesBest(roundTimes, true);
  const { rate: firstRate, breakdown: firstBreakdown } =
    statRoundsFirstRate(roundTimes);
  const { rate: lastRate, breakdown: lastBreakdown } = statRoundsLastRate(
    roundTimesWithLastPos
  );

  //// Disabled for performance reasons
  // const { rate: mistakeRate, breakdown: mistakeBreakdown } =
  //   statTimesMistakeRate(bestTime, roundTimes, allRoundTimes);
  // const { rate: crashRate, breakdown: crashBreakdown } = statTimesCrashRate(
  //   bestTime,
  //   roundTimes,
  //   allRoundTimes
  // );

  const { rate: dnfRate, breakdown: dnfBreakdown } =
    statTimesDnfRate(roundTimes);

  return {
    driverName,
    driverRating,
    orgId,
    orgName,
    bestTime,
    medianTime: statTimesMedian(roundTimes),
    averageFinishPercentile: statRoundsAfPercentile(roundTimesWithLastPos),
    firstRate,
    firstBreakdown,
    lastRate,
    lastBreakdown,
    // mistakeRate,
    // mistakeBreakdown,
    // crashRate,
    // crashBreakdown,
    dnfRate,
    dnfBreakdown,
  };
};
